import { Box } from "@mui/material";
import { Ref, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import clearLocalStorage from "utils/clearlocalStorage";
import octa2 from "../../../assets/images/missions/mission-ten/octa.png";
import ContentAdmin from "../../../components/contentAdmin";
import CustomButton from "../../../components/customButton";
import PanelTitle from "../../../components/missions/PanelTitle";
import useMission from "../hooks/useMission";

const Finish = forwardRef((props: Record<string, any>, ref: Ref<HTMLDivElement>) =>
{
	const navigate = useNavigate();
	const missionContext = useMission();

	function nextMission()
	{
		// if (missionContext.firstPlaythrough)
		// {
		// 	setTimeout(() => missionContext.setStep(11), 0);
		// }
		// else
		// {
		// 	clearLocalStorage("mission-ten");
		// 	navigate("/mission-eleven");
		// }
		clearLocalStorage("mission-ten");
		navigate("/mission-eleven");
	}

	return (
		<Box
			ref={ref}
			{...props}
			sx={{
				height: "84vh",
				width: "100%",
				maxWidth: "840px",
				m: "auto",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				position: "relative",
				top: "-14px",
				left: "11px"
			}}>
			<PanelTitle
				imgDisplay="none"
				color="#215C75"
				gapPanelTitle="25px"
				title={<ContentAdmin
					limit={111}
					keyContent="contentMissionTen"
					keyText="finish_title"
					defaultValue="Psst, {NAME}! I’ve got a\n surprise for you ;)"
					position="top"
				/>}
			/>
			<Box sx={{
				width: "512px",
				height: "480px",
				m: "70px auto 10px",
				position: "relative",
				top: "15px",
				left: "-8px"
			}}>
				<img width="100%" src={octa2} alt="guide-chara" />

			</Box>
			<Box sx={{
				display: "flex",
				justifyContent: "center",
				position: "relative",
				top: "-26px"
			}}>
				<CustomButton.Outline
					onClick={nextMission}
					sx={{
						background: "#3E809D",
						border: "#3E809D",
						color: "#fff"
					}}
				>
					{/* SURPRISE-&gt; Mission 11 */}
					Claim my gift
				</CustomButton.Outline>
			</Box>
		</Box>
	);
});

export default Finish;
